import {QuotasPermissions, RegistersListsMenuPermissions} from 'src/common/utils/PermissionsList'

import {createRouteSegmentMatcher, createSiblingRouteMatcher, type NavigationMenuVisibilityRule} from './apply-navigation-menu-visibility'

const REGISTERS_LISTS_SEGMENT = 'registers/lists'
const ADMINISTRATIVE_QUOTAS_SEGMENT = 'administrative/quotas'

export const registersListsMenuVisibilityRule: NavigationMenuVisibilityRule = {
  matchesRoute: createRouteSegmentMatcher(REGISTERS_LISTS_SEGMENT),
  permissions: RegistersListsMenuPermissions.map((permission) => permission.name),
  permissionMatch: 'any',
  hideForB2c: true,
  injection: {
    item: {
      id: '__client_registers_lists__',
      key: 'registers_lists',
      label: 'Listas',
      route: '/registers/lists',
      segment: 'registers-lists',
    },
    shouldInjectWhenSiblings: createSiblingRouteMatcher({
      includes: '/registers/',
      excludes: REGISTERS_LISTS_SEGMENT,
    }),
  },
}

export const administrativeQuotasMenuVisibilityRule: NavigationMenuVisibilityRule = {
  matchesRoute: createRouteSegmentMatcher(ADMINISTRATIVE_QUOTAS_SEGMENT),
  permissions: QuotasPermissions.map((permission) => permission.name),
  permissionMatch: 'any',
  hideForB2c: true,
  injection: {
    item: {
      id: '__client_administrative_quotas__',
      key: 'administrative_quotas',
      label: 'Cotas',
      route: '/administrative/quotas',
      segment: 'administrative-quotas',
    },
    shouldInjectWhenSiblings: createSiblingRouteMatcher({
      includes: '/administrative/',
      excludes: ADMINISTRATIVE_QUOTAS_SEGMENT,
    }),
  },
}

export const navigationMenuVisibilityRules: readonly NavigationMenuVisibilityRule[] = [registersListsMenuVisibilityRule, administrativeQuotasMenuVisibilityRule]
